import { onMounted, onUnmounted } from 'vue';
import {phone} from 'phone';
export default function useGoogleManager(){

    type GtmPurchaseItem = {
        item_id: string;
        item_name: string;
        affiliation: string;
        currency: string;
        item_variant: string;
        price: number;
        quantity: number;
    }

    type GtmEcommerce = {
        currency: string;
        transaction_id: string;
        affiliation: string;
        value: number;
        items?: GtmPurchaseItem[];
    }

    type GtmLocationEvent = {
        latitude: number;
        longitude: number;
        zip_code: string;
        market_type: string;
        distance: number;
    }

    function gtmPurchaseEvent(order, affiliation){
        function executeLogic() {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({ ecommerce: null });
            let ecommerce: GtmEcommerce = {
            currency: 'USD',
            transaction_id: order.order_id,
            affiliation,
            value: order.total,
            };
            let gtmItems: GtmPurchaseItem[] = [];
            order.items.forEach(item => {
            gtmItems.push({
                item_id: item.variation.rothco_item_index,
                item_name: item.variation.item_name,
                affiliation,
                currency: 'USD',
                item_variant: item.variation.item_variation_id,
                price: item.price,
                quantity: item.quantity,
            });
            });

            if (gtmItems.length > 0) {
                ecommerce.items = gtmItems;
            }

            

            let enhanced_conversion_data = {
                email: order.billing_email,
                phone: phone(order.billing_phone, {country: order.shipping_country})?.phoneNumber || '',
                address: order.shipping_address + (order.shipping_address_2 ? `, ${order.shipping_address_2}` : ''),
                city: order.shipping_city,
                state: order.shipping_state,
                postal_code: order.shipping_zip,
                country: order.shipping_country,
            }
            dataLayer.push({
                event: 'purchase',
                ecommerce: ecommerce,
                enhanced_conversion_data: enhanced_conversion_data
            });
        }

        if (window.userDataIsReady === true) {
            executeLogic();
        } else {
            window.addEventListener('userDataIsReady', () => {
            executeLogic();
            }, { once: true });
        }

    }

    function gtmBeginCheckoutEvent(total) {
        function executeLogic() {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({ ecommerce: null });
            let ecommerce = {
                currency: 'USD',
                value: total,
            };
            dataLayer.push({
                event: 'begin_checkout',
                ecommerce: ecommerce
            });
        }

        if (window.userDataIsReady === true) {
            executeLogic();
        } else {
            window.addEventListener('userDataIsReady', () => {
                executeLogic();
            }, { once: true });
        }
    }


    function gtmAddShippingInfoEvent(total) {
        function executeLogic() {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({ ecommerce: null });
            let ecommerce = {
                currency: 'USD',
                value: total
            };
            dataLayer.push({
                event: 'add_shipping_info',
                ecommerce: ecommerce
            });
        }

        if (window.userDataIsReady === true) {
            executeLogic();
        } else {
            window.addEventListener('userDataIsReady', () => {
                executeLogic();
            }, { once: true });
        }
    }

    function gtmAddPaymentInfoEvent(total){
        function executeLogic() {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({ ecommerce: null });
            let ecommerce = {
                currency: 'USD',
                value: total
            };
            dataLayer.push({
                event: 'add_payment_info',
                ecommerce: ecommerce
            });
        }
        if (window.userDataIsReady === true) {
            executeLogic();
        } else {
            window.addEventListener('userDataIsReady', () => {
                executeLogic();
            }, { once: true });
        }
    }


    function gaPurchaseTransaction(order){
        try{
            ga('require', 'ecommerce');
            ga('ecommerce:addTransaction', {
                'id': order.order_id,
                'affiliation': 'B2C Website',
                'revenue': +(order.subtotal).toFixed(2),
                'shipping': order.shipping_charge,
                'tax': order.sales_tax,
            });

            order.items.forEach(item => {
                ga('ecommerce:addItem', {
                    'id': order.order_id,
                    'name': item.variation.item.name,
                    'sku': item.variation.rothcoItem.rothco_item_no,
                    'price': item.price,
                    'quantity': item.quantity
                });
            });

            ga('ecommerce:send');

        }catch(err){

        }
    }

    function gtmSearchResultsEvent(searchTerm){
        function executeLogic(){
            gtag('event', 'view_search_results', {
                search_term: searchTerm
            });
        }

        if (window.userDataIsReady === true) {
            executeLogic();
        } else {
            window.addEventListener('userDataIsReady', () => {
                executeLogic();
            }, { once: true });
        }
    }


    function googleConversion(order){
        try{
            gtag('event', 'conversion', {
                'send_to': 'AW-1071584415/5YO9COzKxXsQn6n8_gM',
                'value': order.total,
                'currency': 'USD',
                'transaction_id': order.order_id,
            });
        }catch(err){

        }
       
    }


    function gtmCustomEvent(event: string, ecommerce?: GtmEcommerce){
        function executeLogic() {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({ ecommerce: null });
            dataLayer.push({
                event,
                ecommerce
            });
        }

        if (window.userDataIsReady === true) {
            executeLogic();
        } else {
            window.addEventListener('userDataIsReady', () => {
                executeLogic();
            }, { once: true });
        }
    }

    function gtmRetailLocatorEvent(location: GtmLocationEvent){
        function executeLogic() {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
                event: 'dealer_locator',
                ...location
            });
        }

        if (window.userDataIsReady === true) {
            executeLogic();
        } else {
            window.addEventListener('userDataIsReady', () => {
                executeLogic();
            }, { once: true });
        }
    }

    function gtmViewItemListEvent(moduleName, items){
        function executeLogic() {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({ ecommerce: null });
            let ecommerce = {
                item_list_name: moduleName,
                items
            };
            dataLayer.push({
                event: 'view_item_list',
                ecommerce,
                moduleName
            });
        }

        if (window.userDataIsReady === true) {
            executeLogic();
        } else {
            window.addEventListener('userDataIsReady', () => {
                executeLogic();
            }, { once: true });
        }
    }

    function gtmViewItem(item, quantity){
        function executeLogic() {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({ ecommerce: null });
            let ecommerce = {
                value: item.price * quantity,
                currency: 'USD',
                items: [{
                    item_id: item.rothcoItem.rothco_item_no,
                    item_name: item.item.name,
                    item_variant: item.item_variation_id,
                    price: item.price,
                    quantity: quantity,
                }]
            };
            dataLayer.push({
                event: 'view_item',
                ecommerce
            });
        }

        if (window.userDataIsReady === true) {
            executeLogic();
        } else {
            window.addEventListener('userDataIsReady', () => {
                executeLogic();
            }, { once: true });
        }
    }

    function gtmAddToCartEvent(item){
        function executeLogic() {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({ ecommerce: null });
            let price = item.price ? +item.price : 0;
            let quantity = item.quantity ? +item.quantity : 1;
            let ecommerce = {
                currency: 'USD',
                value: price * quantity,
                items: [{
                    item_id: item.rothcoItem.rothco_item_no,
                    item_name: item.item.name,
                    item_variant: item.item_variation_id,
                    price: price,
                    quantity: quantity,
                }]
            };
            dataLayer.push({
                event: 'add_to_cart',
                ecommerce
            });
        }

        if (window.userDataIsReady === true) {
            executeLogic();
        } else {
            window.addEventListener('userDataIsReady', () => {
                executeLogic();
            }, { once: true });
        }
    }

    function gtmRemoveItemFromCartEvent(item){
        function executeLogic() {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({ ecommerce: null });
            let price = item.price ? +item.price : 0;
            let quantity = item.quantity ? +item.quantity : 1;
            let ecommerce = {
                currency: 'USD',
                value: price * quantity,
                items: [{
                    item_id: item.rothcoItem.rothco_item_no,
                    item_name: item.item.name,
                    item_variant: item.item_variation_id,
                    price: price,
                    quantity: quantity,
                }]
            };
            dataLayer.push({
                event: 'remove_from_cart',
                ecommerce
            });
        }

        if (window.userDataIsReady === true) {
            executeLogic();
        } else {
            window.addEventListener('userDataIsReady', () => {
                executeLogic();
            }, { once: true });
        }
    }

    return { gtmAddPaymentInfoEvent, gtmAddShippingInfoEvent, gtmBeginCheckoutEvent, gtmPurchaseEvent, gaPurchaseTransaction, gtmRetailLocatorEvent, gtmViewItemListEvent, gtmViewItem, gtmAddToCartEvent, gtmRemoveItemFromCartEvent, gtmSearchResultsEvent, gtmCustomEvent, googleConversion,  };
}